import { Reducer } from 'redux/utils/Value'

import actionTypes from './referralRequestCancelActionTypes'
import InitialState from './ReferralRequestCancelInitialState'

export default Reducer({ actionTypes, stateClass: InitialState })